export const FETCH_USERS = 'FETCH_USERS';